import { Component, OnInit, ViewChild, isDevMode } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FruHttpService } from '../../../../services/fru-http.service';
import { LandingData } from '../../../../shared/landing-data';
import { FormLandingHeaderDirective } from './form-landing-header.directive';
import { FormLandingHeaderComponent } from './fru/form-landing-header/form-landing-header.component';
import { FormLandingFooterDirective } from './form-landing-footer.directive';
import { FormLandingFooterComponent } from './fru/form-landing-footer/form-landing-footer.component';
import { FormLandingBodyDirective } from './form-landing-body.directive';
import { FormLandingBodyComponent } from './fru/form-landing-body/form-landing-body.component';
import { MMLandingHeaderComponent } from './mm/mmlanding-header/mmlanding-header.component';
import { MMLandingBodyComponent } from './mm/mmlanding-body/mmlanding-body.component';
import { MMLandingFooterComponent } from './mm/mmlanding-footer/mmlanding-footer.component';
import { BestLandingHeaderComponent } from './best/best-landing-header/best-landing-header.component';
import { BestLandingBodyComponent } from './best/best-landing-body/best-landing-body.component';
import { BestLandingFooterComponent } from './best/best-landing-footer/best-landing-footer.component';
import { LeadReferrerService } from '../../../../services/lead-referrer.service';
import { Title, Meta } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { LeadReferrer } from '../../../../shared/lead-referrer';
import { BrandData } from '../../../../shared/brand-data';
import { BrandService } from '../../../../services/brand.service';
import { AnalyticsService } from '../../../../services/analytics.service';
import { LoadScripts } from '../../../../services/load-scripts.service';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { StateService } from '../../../../services/state.service';

declare global {
  interface Window {
    Elm: any;
  }
}

@Component({
    selector: 'app-form-landing',
    templateUrl: './form-landing.component.html',
    styleUrls: ['./form-landing.component.scss'],
    standalone: false
})
export class FormLandingComponent implements OnInit {
  @ViewChild(FormLandingHeaderDirective, { static: true }) header: FormLandingHeaderDirective;
  @ViewChild(FormLandingFooterDirective, { static: true }) footer: FormLandingFooterDirective;
  @ViewChild(FormLandingBodyDirective, { static: true }) body: FormLandingBodyDirective;
	
  adnetwork: string = '';
  leadType: string = '';
  state: string = '';
  landingData: LandingData;
  headerComponent: any = null;
  bodyComponent: any = null;
  footerComponent: any = null;

  constructor(
    private analyticsService: AnalyticsService,
    private brandService: BrandService,
    private cookieService: CookieService,
    private fruHttp: FruHttpService,
    private leadReferrerService: LeadReferrerService,
    private route: ActivatedRoute,
    private stateService: StateService,
    private title: Title,
    private meta: Meta,
    private loadScripts: LoadScripts,
  ) {}

  addFaviconLinks(path: string) {
    const link1: HTMLLinkElement = document.createElement('link');
    link1.setAttribute('rel', 'icon');
    link1.setAttribute('type', 'image/png');
    link1.setAttribute('sizes', '32x32');
    link1.setAttribute('href', path + 'favicon-32x32.png');
    document.head.appendChild(link1);

    const link2: HTMLLinkElement = document.createElement('link');
    link2.setAttribute('rel', 'icon');
    link2.setAttribute('type', 'image/png');
    link2.setAttribute('sizes', '16x16');
    link2.setAttribute('href', path + 'favicon-16x16.png');
    document.head.appendChild(link2);

    const link3: HTMLLinkElement = document.createElement('link');
    link3.setAttribute('rel', 'apple-touch-icon');
    link3.setAttribute('sizes', '180x180');
    link3.setAttribute('href', path + 'apple-touch-icon.png');
    document.head.appendChild(link3);

    const link4: HTMLLinkElement = document.createElement('link');
    link4.setAttribute('rel', 'manifest');
    link4.setAttribute('href', path + 'site.webmanifest');
    document.head.appendChild(link4);
  }


  ngOnInit() {
    // Set lead_referrer cookie
    this.leadReferrerService.setReferrer();

    // Set click_id cookie if needed
    this.leadReferrerService.setClickId();

    // Load Tests for Angular page
    this.loadScripts.loadScript('/js/mm_include_tests.js');

    // Add favicon links
    if (this.brandService.data.domain === 'top10bestlenders.com') {
      this.addFaviconLinks('/application/views/www/public/assets/img/top10-favicon-files/');
    }

    // Get things from the query string
    this.route.queryParams.subscribe(params => {
      this.leadType = params.LoanPurpose || '';
      if (this.brandService.pageType === 'default' && params.type) {
        this.brandService.pageType = params.type;
      }
      // Refresh if no LoanPurpose
      if (!params.LoanPurpose && !sessionStorage.getItem('formLandingRefreshed')) {
        sessionStorage.setItem('formLandingRefreshed', 'true'); // make sure runs only once
        setTimeout(() => {
          window.location.reload();
        }, 500);
        return;
      }
    });

    // Get adnetwork
    this.adnetwork = this.leadReferrerService.getAdnetwork();

    // Get page data
    this.getPageData();
    
    // Build page
    this.buildTemplate();

    this.analyticsService.trackQuestionShown('loanType');
  }

  buildTemplate() {
    const classMap = {
      fruHeader:  FormLandingHeaderComponent,
      fruBody:    FormLandingBodyComponent,
      fruFooter:  FormLandingFooterComponent,
      mmHeader:   MMLandingHeaderComponent,
      mmBody:     MMLandingBodyComponent,
      mmFooter:   MMLandingFooterComponent,
      bestHeader: BestLandingHeaderComponent,
      bestBody:   BestLandingBodyComponent,
      bestFooter: BestLandingFooterComponent,
    };

    // Build header
    let headerViewContainerRef = this.header.viewContainerRef;
    headerViewContainerRef.clear();
    this.headerComponent = headerViewContainerRef.createComponent(classMap[this.brandService.view + 'Header'].prototype.constructor);

    // Build body
    let bodyViewContainerRef = this.body.viewContainerRef;
    bodyViewContainerRef.clear();
    this.bodyComponent = bodyViewContainerRef.createComponent(classMap[this.brandService.view + 'Body'].prototype.constructor);


    // Build footer
    let footerViewContainerRef = this.footer.viewContainerRef;
    footerViewContainerRef.clear();
    this.footerComponent = footerViewContainerRef.createComponent(classMap[this.brandService.view + 'Footer'].prototype.constructor);

    // If somehow the ajax call finished before now
    if (typeof this.landingData !== 'undefined') {
      this.populateTemplates();
    }
  }

  populateTemplates() {
    // Make sure the view is done rendering
    if (this.headerComponent !== null && this.bodyComponent !== null && this.footerComponent !== null) {
      // Send needed data to views
      this.headerComponent.instance.officeStatus = this.landingData.officeStatus;
      this.footerComponent.instance.officeStatus = this.landingData.officeStatus;
      this.bodyComponent.instance.officeStatus = this.landingData.officeStatus;
      this.headerComponent.instance.headerText = this.landingData.pageData.h1;
      this.bodyComponent.instance.headerText = this.landingData.pageData.h1;
      this.bodyComponent.instance.state = this.state;

      if(document.location.search.indexOf('best=best') > -1) {
        // Do not show the ads if they have this param, which usually means
        // they just saw a top10 ad and clicked through. Don't show them
        // more ads.
        return;
      }
    }
  }

  // Get page data
  public getPageData() {
    // deepcode ignore Ssrf: getLandingPageData does a get call to a specified url (wwwUrl), it only uses the params to generate the query string
    combineLatest([this.fruHttp.getLandingPageData(this.leadType, this.adnetwork, this.brandService.pageType),
      this.fruHttp.getLandingPageState()])
      .pipe(
        map(
          ([landingData, stateResponse]) => ({landingData: landingData, stateResponse: stateResponse})
        )
      ).subscribe((response: any) => {
        // Set meta description
        const prettyDomain = this.brandService.data.prettyDomain || 'FreerateUpdate';
        this.brandService.updateMetaDescription(this.meta);

        this.landingData = response.landingData;
        this.state = response.stateResponse.state;
        this.stateService.setStateAbbreviation(this.state);
        this.populateTemplates();
        this.title.setTitle(`Mortgage Refinance & Purchase, Home Equity & Cash Out Loans | ${prettyDomain}`);

        // Add open graph social media link preview
        if (this.brandService.isTop10) {
          const ogTitle = this.title.getTitle();
          const ogUrl = document?.location?.href || '';
          const ogImage = 'https://www.top10bestlenders.com/application/views/www/public/assets/img/top10-social-media/top10-social-media-link-preview-1200x630.jpg';
          const ogDescription = this.meta.getTag('name=description')?.content || 'Compare top mortgage lenders for low rates, reviews, and personalized deals.';
          const tags: Array<any> = [
            { property: 'og:title', content: ogTitle },
            { property: 'og:description', content: ogDescription },
            { property: 'og:image', content: ogImage },
            { property: 'og:url', content: ogUrl },
            { property: 'og:type', content: 'website' },
            { property: 'og:site_name', content: prettyDomain },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: ogTitle },
            { name: 'twitter:description', content: ogDescription },
            { name: 'twitter:image', content: ogImage },
          ];
          tags.forEach(tag =>
            this.meta.updateTag(tag, tag.property ? `property='${tag.property}'` : `name='${tag.name}'`)
          );
        }
    });
  }
}
